export default __webpack_public_path__ + "static/media/perspective-dice-six-faces-random.73f7594f.png";